import { Injectable, OnDestroy } from '@angular/core';
import { CheckinBaseClass } from '../../components';
import {
  StandbyEntryCompletionResultState,
  resetStandbyEntryCompletionResult,
  selectStandbyEntryCompletionResultState,
  setStandbyEntryCompletionResultFromApi,
} from '../../store/standby-entry-completion-result';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, pairwise } from 'rxjs/operators';
import {
  PostStandbyCompleteEntryRequest,
  PostStandbyCompleteEntryResponse,
  DefaultService as Api,
} from 'src/sdk_checkin';

@Injectable()
export class StandbyEntryCompletionResultStoreService extends CheckinBaseClass {
  private _result$: Observable<StandbyEntryCompletionResultState>;
  private _result!: StandbyEntryCompletionResultState;
  get result() {
    return this._result;
  }

  constructor(private _store: Store<StandbyEntryCompletionResultState>, private api: Api) {
    super();
    this._result$ = this._store.pipe(
      select(selectStandbyEntryCompletionResultState),
      filter((data) => !!data)
    );
    this.subscribeService(this._result$, (data) => {
      this._result = data;
    });
  }

  override destroy(): void {}

  /**
   * StandbyEntryCompletionResultStateStore のObservableを返却する
   * @returns StandbyEntryCompletionResultStateStore の全ての値を取得するObservable
   */
  public getResultState$() {
    return this._result$;
  }

  /**
   * PostStandbyEntryCompletionResponse を取得するObservableを返却する
   * @returns
   */
  public getResponse$() {
    return this._result$.pipe(filter((data) => !!data.model));
  }

  /**
   * store名がstandbyEntryCompletionResultのstoreを返却する
   * @returns store名がstandbyEntryCompletionResultのstore
   */
  public getStore() {
    return this._store.pipe(select(selectStandbyEntryCompletionResultState));
  }

  /**
   * エラーが発生していない空席待ちエントリー確定APIのレスポンス通知
   */
  get success$() {
    return this._result$.pipe(
      pairwise(),
      filter(([prev, curr]) => prev.isPending === true && curr.isPending === false && curr.isFailure === false),
      map(([_, curr]) => curr)
    );
  }

  /**
   * エラーが発生している空席待ちエントリー確定APIのレスポンス通知
   */
  get failure$() {
    return this._result$.pipe(filter((state) => state.isFailure === true));
  }

  /**
   * API呼び出し結果のObservableを受け取りStoreに格納する
   * @param call API呼び出し結果を取得するObservable
   */
  public setResult(call: Observable<PostStandbyCompleteEntryResponse>) {
    this._store.dispatch(setStandbyEntryCompletionResultFromApi({ call }));
  }

  /**
   * 空席待ちエントリー確定APIを呼び出す
   * @param parameter 空席待ちエントリー確定APIのリクエストパラメータ
   */
  callApi(parameter: PostStandbyCompleteEntryRequest): void {
    const call = this.api.standbyCompleteEntryPost(parameter);
    this.setResult(call);
  }

  /**
   * 空席待ちエントリー確定結果ストアをクリアする
   */
  clear(): void {
    this._store.dispatch(resetStandbyEntryCompletionResult());
  }
}
